import React, { Component } from 'react';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import LineChart from 'recharts/lib/chart/LineChart';
import Line from 'recharts/lib/cartesian/Line';
import XAxis from 'recharts/lib/cartesian/XAxis';
import YAxis from 'recharts/lib/cartesian/YAxis';
import CartesianGrid from 'recharts/lib/cartesian/CartesianGrid';
import Tooltip from 'recharts/lib/component/Tooltip';
import Legend from 'recharts/lib/component/Legend';
import ReferenceLine from 'recharts/lib/cartesian/ReferenceLine';


import { connect } from "react-redux";
// import { number } from 'prop-types';


// import { scalePoint } from 'd3-scale';
// const scale = scalePoint().base(Math.E);

class StrengthChart extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pos: 0.
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pos !== this.props.pos) {
      this.setState({ pos: nextProps.pos });
    }

  }

  // let str =  props.pos;
  render() {
    // const {pos} = this.state.pos;

    return (

      // console.log('props.pos', this.props.pos);
      // 99% per https://github.com/recharts/recharts/issues/172
      <ResponsiveContainer width="99%" height="80%">

        <LineChart data={this.props.vehicles} syncId="anyId">
          <ReferenceLine x={this.props.pos} stroke="red" label="" />
          <XAxis dataKey="timestamp"    tick={false} />
          <YAxis />
          <CartesianGrid vertical={false} strokeDasharray="3 3" />
          <Tooltip />
          {/* <Legend  /> */}

          <Line type="monotone" dataKey="rssi" stroke="#82ca9d" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    vehicles: state.vehicles
  }
}

export default connect(mapStateToProps)(StrengthChart);
